import React, { useState } from "react";
import { HiChevronDown } from "react-icons/hi";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import Container from "../layout/Container";
import { Pip } from "../characters/Character";
import { SoftCircle } from "../characters/Decor";
import { useI18n } from "../../i18n/I18nProvider";

const Faq = () => {
  const [open, setOpen] = useState(0);
  const [surprised, setSurprised] = useState(false);
  const reduced = useReducedMotion();
  const { t, dir } = useI18n();
  const items = [1, 2, 3, 4].map((n) => ({
    q: t(`faq.q${n}`),
    a: t(`faq.a${n}`),
  }));

  const toggle = (index) => {
    const next = open === index ? -1 : index;
    setOpen(next);
    if (next !== -1 && !reduced) {
      setSurprised(true);
      window.setTimeout(() => setSurprised(false), 600);
    }
  };

  return (
    <section id="faq" className="scroll-mt-24 py-16 md:py-24">
      <Container>
        <div className="grid items-start gap-10 lg:grid-cols-[minmax(0,0.7fr)_minmax(0,1.3fr)]">
          <div>
            <div className="relative inline-flex">
              <SoftCircle className="pointer-events-none absolute -left-6 -top-4 h-24 w-24" />
              <Pip size={140} mood={surprised ? "surprised" : "neutral"} className="relative" />
            </div>
            <h2 className="mt-6 max-w-sm text-heading font-bold tracking-heading text-ink">
              {t("faq.title")}
            </h2>
          </div>
          <div>
            {items.map((item, index) => {
              const isOpen = open === index;
              return (
                <div key={item.q} className="border-b border-hairline first:border-t">
                  <button
                    type="button"
                    className={`flex min-h-11 w-full items-center justify-between gap-4 py-4 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent ${
                      dir === "rtl" ? "text-right" : "text-left"
                    }`}
                    aria-expanded={isOpen}
                    onClick={() => toggle(index)}
                  >
                    <span className="text-body font-medium text-ink">{item.q}</span>
                    <HiChevronDown
                      className={`shrink-0 text-mid-gray transition-transform ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      size={22}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen ? (
                      <motion.div
                        initial={reduced ? false : { height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={reduced ? undefined : { height: 0, opacity: 0 }}
                        transition={{ type: "spring", bounce: 0.18, duration: 0.45 }}
                        className="overflow-hidden"
                      >
                        <p className="pb-5 text-body text-mid-gray">{item.a}</p>
                      </motion.div>
                    ) : null}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Faq;
